// extracted by mini-css-extract-plugin
export default {"header":"H38w0","date":"XBHHX","content":"JA9rN"};